<template>
  <div :class="[$style.container, active ? $style.active : {}]">
    <div :class="$style.body">
      <div :class="$style.content">
        <slot name="content" />
      </div>
      <div v-if="buttonLabel" :class="$style.footer">
        <BaseButton :class="$style.footerButton" @click="closeModal()">
          {{ buttonLabel }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

defineProps({
  active: {
    type: Boolean,
    default: false
  },
  buttonLabel: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['closed'])

const closeModal = () => {
  emits('closed', true)
}
</script>

<style module>
.container {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  z-index: 25;
  background: rgba(66, 85, 99, 0.9);
  padding: 12px 14px;
}

.active {
  display: flex;
  align-items: center;
  justify-content: center;
}

.body {
  position: relative;
  background: var(--color-white);
  border-radius: 8px;
  max-width: 640px;
  padding: 0 22px 48px;
  /* subtrating header and footer area */
  max-height: calc(100vh - 40px);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
}

.content {
  position: relative;
}

.footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 12px 0;
  background-color: var(--color-grey1);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.footerButton {
  padding: 8px 40px;
  width: auto;
  box-shadow: 0 2px 2px rgba(21, 137, 153, 0.25);
}

.fullWidth {
  width: calc(100% + 64px);
  margin-left: -22px;
  padding-top: 0;
}

.indent {
  padding: 0 20px;
}

.summary {
  font-size: 16px;
  line-height: 19px;
}
</style>
